import { makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Styles from "./index.module.scss";
import { convertNumberToPersian } from "../../../method/convertDigitToEnglish";
import { useDispatch } from "react-redux";
import { actionTypes as actionTypesNotif} from './../../../../redux/notificationAlert'

let useStyles = makeStyles((theme) => ({
  tableParent: {
    width: "100%",
    paddingBottom: 15,
    overflow: 'auto',
  },
  table: {
    backgroundColor: "#f2f2f2",
    width: "100%",
    textAlign: 'left',
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: "60%",
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    border: 0,
    outline: 0,
    padding: theme.spacing(2, 4, 3),
    position: "relative",
    paddingTop: 40,
    [theme.breakpoints.down("1000")]: {
      width: "100%",
    },
  },
  title: {
    width: '100%',
    textAlign: 'left',
    // backgroundColor: "#f2f2f2",
  },
  FileCopyOutlinedIcon: {
    // color:'#3f51b5',
    color: 'rgba(0, 0, 0, 0.54)',
    cursor: 'pointer',
    // fontSize:20,
    width: 10,
    marginLeft: 10,
    '&:hover': {
      color: '#3f51b5',
    },
  }
}));



const Index = ({ head, data }) => {

  const classes = useStyles();
  let dispach = useDispatch()

  const [state, setState] = useState({ body: [], id: '' });

  useEffect(() => {
    if (data) {
      setState(data)
    }
  }, [data]);


  const copyContent = async (data) => {
    try {
      await navigator.clipboard.writeText(data);
      dispach({ 
        type:actionTypesNotif?.success ,
        textAlert:'متن کپی شد'
      })

    } catch (err) {
      dispach({ 
        type:actionTypesNotif?.error ,
        textAlert:'متاسفانه متن کپی نشد'
      })
    }
  }

  return (
    <>
      <div className={`${classes.tableParent} table-responsive `}>
        <h4 className={classes['title']}>
          {state?.id}
        </h4>
        <table className={Styles.table} id="listingTable">
          <thead>
            <tr>
              <th>ردیف</th>
              {head.map((itm, ind) => (
                // <th style={{ minWidth: itm.minWidth }} key={ind}>{itm.label}</th>
                <th key={ind} style={{ paddingLeft: 15 }} >{itm.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {state?.body
              .map((itm, ind) => (
                <tr key={ind}>
                  <td style={{ width: 50, textAlign: 'center' }}>
                    {convertNumberToPersian(ind + 1)}
                  </td>
                  {/* <td>{convertNumberToPersian(itm.title)}</td> */}
                  <td >{convertNumberToPersian(itm.titleBank)}</td>
                  <td
                   onClick={() => copyContent(itm.accountNumber)}
                   style={{ minWidth: 171, textAlign: 'left', paddingLeft: 30, }}
                   >
                    {` ${convertNumberToPersian(itm.accountNumber)} `}
                    <img src={'/assets/icons/copy-icon.svg'} alt className={classes['FileCopyOutlinedIcon']} />
                  </td>
                  <td
                    onClick={() => copyContent(itm.shaba)}
                    style={{ minWidth: 270, textAlign: 'left', paddingLeft: 30, }}
                  >
                    {` ${convertNumberToPersian(itm.shaba)} `}
                    <img src={'/assets/icons/copy-icon.svg'} alt className={classes['FileCopyOutlinedIcon']} />
                  </td>
                  <td >{convertNumberToPersian(itm.shoab)}</td>
                  <td >{convertNumberToPersian(itm.codeShaba)}</td>

                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Index;
